// extracted by mini-css-extract-plugin
export default {"button":"TomatoButton_button__jKVp1","container":"TomatoButton_container__mAQ10"};